import request from '@/utils/request'

const ssoApi = {

}

ssoApi.checkHeartbeat = () => {
  return request({
    url: '/sso/checkHeartbeat',
    method: 'post'
  })
}

// 通过ad域登录
ssoApi.ssoLoginOld = code => {
  return request({
    url: '/ad/login/' + code,
    method: 'get'
  })
}
ssoApi.ssoLogin = code => {
  return request({
    url: '/ad-new/login/' + code,
    method: 'get'
  })
}

ssoApi.getAccessToken = ssoParam => {
  return request({
    url: '',
    method: 'post'
  })
}

export default ssoApi
